import { z } from 'zod';

export const DEVICE_TYPES = ['standalonePrinter', 'posTerminal'] as const;

export const heartbeatSchema = z.object({
  /**
   * Multiple device types are possible. Each map to respective id fields:
   * - `standalonePrinter.imei`
   * - `posTerminal.idForVendor`
   */
  deviceId: z.string(),
  deviceType: z.literal(DEVICE_TYPES),
  /** Extra data for debugging purposes */
  extra: z.any().nullable().default(null),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type Heartbeat = z.output<typeof heartbeatSchema>;

// Convex types
export const heartbeatCvxSchema = heartbeatSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
});
export type HeartbeatCvx = z.output<typeof heartbeatCvxSchema>;
